import { useEffect } from 'react';
import BloodDropIcon from '../brand/BloodDropIcon';
import { MY_ORBCON_LABEL, MY_ORBCON_PANEL_ID, useUserSidebar } from '../../hooks/useUserSidebar';
import MyOrbconPanel from './MyOrbconPanel';

export default function UserSidebar() {
  const { isSignedIn, ready, isOpen, setOpen } = useUserSidebar();

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, setOpen]);

  if (!ready || !isSignedIn) return null;

  return (
    <>
      {isOpen && (
        <button
          type="button"
          className="fixed inset-0 z-30 bg-black/50 md:hidden"
          aria-label={`Close ${MY_ORBCON_LABEL}`}
          onClick={() => setOpen(false)}
        />
      )}

      <MyOrbconPanel />

      <button
        type="button"
        onClick={() => setOpen(true)}
        className="
          group
          hidden md:inline-flex
          fixed right-0 top-32 z-30 print:hidden
          items-center
          h-11
          bg-white text-primary
          border-2 border-r-0 border-accent
          rounded-l-md shadow-md
          text-sm font-semibold
          hover:bg-accent/5 active:bg-accent/5
          transition-colors duration-150 ease-in-out
          motion-reduce:transition-none
          focus-ring
        "
        aria-label={`Open ${MY_ORBCON_LABEL}`}
        aria-controls={MY_ORBCON_PANEL_ID}
        aria-expanded={isOpen}
        aria-hidden={isOpen}
        inert={isOpen}
      >
        <span className="inline-flex h-11 w-11 flex-shrink-0 items-center justify-center">
          <BloodDropIcon className="h-5 w-5 text-accent" />
        </span>
        <span
          className="
            min-w-0 overflow-hidden whitespace-nowrap
            max-w-0
            group-hover:max-w-[6.5rem]
            group-focus-visible:max-w-[6.5rem]
            transition-[max-width] duration-150 ease-in-out
            motion-reduce:transition-none
          "
        >
          <span className="inline-block pr-4">{MY_ORBCON_LABEL}</span>
        </span>
      </button>
    </>
  );
}
